var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanbiology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Human_biology",
    "data-name": "Human biology",
    transform: "translate(21753 -2786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21753 2786)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_65",
    "data-name": "Union 65",
    d: "M25.295,58.066c-3.208-.427-8.548-2.668-14.968-8.3C-1,39.835.2,36.759.2,36.759a13.929,13.929,0,0,1,0-4.84c.529-3.4,2.3-8.487,4.894-11.562a12.755,12.755,0,0,1,5.422-4.27c3.311-.24,7.359-.248,7.359-.248s2.527-5.647,6.6-7.957a14.374,14.374,0,0,1,9.7-1.286c.488.27.01,3.444-.508,4.072s-3.288-.03-5.573,1.328-2.841,2.584-2.916,4.244c-.025.578,1.569,2.111,2.659,3.8,1.559,2.422,3.175,5.365,3.175,5.365a11.814,11.814,0,0,1-1.773,3.935,12.531,12.531,0,0,1-3.322,2.879,12.9,12.9,0,0,1-3.764-4.057c-1.44-2.554-.184-5.723-1.734-5.649s-1.447,2.524-.516,5.241a16.378,16.378,0,0,0,3.73,5.355,13.532,13.532,0,0,0-3.475,4.905c-.933,2.7-1.512,6.2.26,5.942s-.242-3.818,2.878-7.751c1.33-1.675,3.954-2.327,5.942-3.985a12.786,12.786,0,0,0,3.153-4.057,40.244,40.244,0,0,1,3.123,8.6,28.7,28.7,0,0,1,.431,10.993c-1.439,8.012-5.988,9.845-5.988,9.845a7.253,7.253,0,0,1-3.121.576A11.546,11.546,0,0,1,25.295,58.066ZM4.578,54.624v-7.64L9.412,51.56v3.064ZM37,34.5s.519-.113,1.22-.224c.452-.081,1.09-.122,1.141.893.1,1.949-2.145,2.061-2.145,2.061ZM32.615,24.149s1.055-.244,2.494-.527c.923-.193,2.258-.382,2.784.768,1.008,2.207-3.7,2.83-3.7,2.83ZM4.746,12.6l-3.2-6.754,3.2-.653S6.658,7.64,8.24,7.12s3.322-4.06,3.322-4.06l3.318,1.913A28.935,28.935,0,0,0,11.959,9.76a10.062,10.062,0,0,0-.889,3.971,9.827,9.827,0,0,0-2.687,1.112,19.869,19.869,0,0,0-3.637,2.952Zm8.217,1.35a14.817,14.817,0,0,1,1.9-5.372,23.637,23.637,0,0,1,4.4-4.9S19.055.668,19.471.21,22.094.166,22.53.319s.277,1.25.873,1.834a2.915,2.915,0,0,0,1.943.917,3.663,3.663,0,0,0,2.3-1.137c.769-.658,1.408-1.317,1.888-1.091,1.506.634.664,1.445.545,1.857-.212.941.13,1.485,0,1.747s-4.608.358-8.014,2.73a17.613,17.613,0,0,0-5.242,6.77Z",
    transform: "translate(-21728.182 2801.414)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanbiology);
export default __webpack_public_path__ + "static/media/Human biology.e71c0e3c.svg";
export { ForwardRef as ReactComponent };